import { addDataLayerEntry, Events } from '@printdeal/data-layer-manager';

export const dispatchDataLayerStickyHeaderView = () => {
  const eventCategory = 'sticky_header';
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory,
      eventAction: 'view',
      eventNonInteraction: true,
    },
  });
  addDataLayerEntry(eventCategory, {
    eventAction: 'view',
    eventNonInteraction: true,
  });
};

export const dispatchDataLayerUspBarItemClick = (eventLabel: string = ''): void => {
  const eventCategory = 'USP_Bar_Item_click';
  const eventAction = 'click';
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory,
      eventAction,
      eventLabel,
    },
  });
  addDataLayerEntry(eventCategory, {
    eventAction,
    eventLabel,
  });
};
